import React, { useState, useEffect } from 'react';
/* global axios */
import api from '../services/apiService';

const EmployeeTimeLogsForm = () => {
  const [timeLogs, setTimeLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Alle EmployeeTimeLogs abrufen
  useEffect(() => {
    const fetchTimeLogs = async () => {
      try {
        const response = await api.get('/employeeTimeLogs');
        setTimeLogs(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTimeLogs();
  }, []);

  // Lokale Änderungen in einem Eintrag speichern
  const handleChange = (index, field, value) => {
    const newLogs = [...timeLogs];
    newLogs[index] = { ...newLogs[index], [field]: value };
    setTimeLogs(newLogs);
  };

  // Aktualisiert den einzelnen Eintrag im Backend
  const handleSave = async (log) => {
    setError('');
    setSuccess('');
    try {
      await api.put(`/employeeTimeLogs/${log.id}`, log);
      setSuccess(`TimeLog ${log.id} erfolgreich aktualisiert.`);
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <div>Daten werden geladen...</div>;
  if (error) return <div style={{ color: 'red' }}>Fehler: {error}</div>;

  return (
    <div style={{ maxWidth: '1000px', margin: '20px auto' }}>
      <h2>Employee TimeLogs bearbeiten</h2>
      {success && <p style={{ color: 'green' }}>{success}</p>}
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid #ccc', textAlign: 'center',}}>
            <th>ID</th>
            <th>Datum</th>
            <th>Startzeit</th>
            <th>Endzeit</th>
            <th>Geplante Startzeit</th>
            <th>Geplante Endzeit</th>
            <th>Pausenzeit (Min.)</th>
            <th>Dauer (Std.)</th>
            <th>Fertig</th>
            <th>Mitarbeiter</th>
            <th>WA-Nummer</th>
            <th>Maschine</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {timeLogs.map((log, index) => (
            <tr key={log.id} style={{ borderBottom: '1px solid #ccc', textAlign: 'center' }}>
              <td>{log.id}</td>
              <td>{log.date}</td>
              <td>
                <input
                  type="time"
                  value={log.startTime || ''}
                  onChange={(e) => handleChange(index, 'startTime', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="time"
                  value={log.endTime || ''}
                  onChange={(e) => handleChange(index, 'endTime', e.target.value)}
                />
              </td>
              <td>{log.plannedStartTime || '-'}</td>
              <td>{log.plannedEndTime || '-'}</td>
              <td>
                <input
                  type="number"
                  value={log.pauseTime}
                  onChange={(e) => handleChange(index, 'pauseTime', e.target.value)}
                  style={{ width: '70px' }}
                />
              </td>
              <td>{log.duration || '-'}</td>
              <td>
                <input
                  type="checkbox"
                  checked={log.finished || false}
                  onChange={(e) => handleChange(index, 'finished', e.target.checked)}
                />
              </td>
              <td>
                {log.assignment?.employee
                  ? `${log.assignment.employee.firstName} ${log.assignment.employee.lastName}`
                  : 'N/A'}
              </td>
              <td>
                {log.assignment?.workshopOrder
                  ? log.assignment.workshopOrder.workshopOrderNumber
                  : 'N/A'}
              </td>
              <td>
                {log.assignment?.workshopOrder?.item
                  ? log.assignment.workshopOrder.item.name
                  : 'N/A'}
              </td>
              <td>
                <button onClick={() => handleSave(log)}>Speichern</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EmployeeTimeLogsForm;
